import { find, last, take, trimEnd } from 'lodash';

export const mapContentToComponent = (content) => {
  const isResource = content.categories?.nodes?.find((cat) => {
    return cat.slug === 'homeowner-resources';
  });

  if (isResource) {
    return mapResourceToComponent(content);
  } else {
    return mapBlogToComponent(content);
  }
};

export const mapBlogToComponent = (content) => {
  if (content) {
    let blogCategories = content.categories?.nodes.filter(
      (cat) => cat.slug !== 'financial-goals' && cat.slug !== 'blog',
    );
    return {
      image: content.blogFields?.cardImage?.sourceUrl || content.featuredImage?.node?.sourceUrl,
      alt: content.blogFields?.cardImage?.altText || content.featuredImage?.node?.altText,
      category: last(blogCategories)?.name,
      title: content.title,
      link: content.link || content.uri,
    };
  } else {
    return null;
  }
};

export const mapResourceToComponent = (content) => {
  if (content?.homeownerResourceFields) {
    const resource = content.homeownerResourceFields;
    const category = content.categories?.nodes?.find((cat) => {
      return cat.slug !== 'homeowner-resources';
    });
    const categoryName = trimEnd(category?.name || '', 's');

    let categoryAction = `View ${categoryName}`;
    if (categoryName === 'Guide') {
      categoryAction = `Download Guide`;
    } else if (categoryName === 'Video') {
      categoryAction = `Watch Video`;
    }

    return {
      image: resource.resourceCardImage?.sourceUrl || content.featuredImage?.node?.sourceUrl,
      alt: resource.resourceCardImage?.altText || content.featuredImage?.node?.altText,
      category: categoryName,
      categoryURL: category?.uri?.replace('/category', ''),
      description: resource?.resourceCardText,
      arrowLabel: categoryAction,
      title: resource.resourceCardTitle || content.title,
      link: content.uri,
    };
  } else {
    return null;
  }
};

export const mapStoryToComponent = (story) => {
  if (story?.homeownerStoryFields?.pullQuote) {
    return {
      link: story.link,
      homeownerName: story.homeownerStoryFields.homeownerName,
      homeownerLocation: story.homeownerStoryFields.city + ', ' + story.homeownerStoryFields.state,
      profilePic: story.cardImageOverride?.sourceUrl || story.featuredImage?.node?.sourceUrl,
      children: story.homeownerStoryFields.pullQuote[0].text,
    };
  } else {
    return null;
  }
};

export const mapUseCasesToComponent = (useCase) => {
  if (useCase.useCaseFields) {
    return {
      title: useCase.useCaseFields.cardTitleOverride,
      description: useCase.useCaseFields.abstract,
      image: useCase.useCaseFields.cardImageOverride.sourceUrl,
      link: useCase.uri,
    };
  } else {
    return null;
  }
};

export const mapInfoDataToComponent = (card) => {
  return { ...card, image: card.image.sourceUrl, alt: card.image.altText };
};

const filterByCategory = (items, category) => {
  return items.filter((item) => {
    return find(item.categories.nodes, { name: category });
  });
};

export const filterContentByCategory = (content, category) => {
  const groupItems = content.allWpPost.nodes.filter((item) => {
    return !find(item.categories.nodes, { name: 'Homeowner Stories' });
  });
  return take(filterByCategory(groupItems, category), 3);
};

export const filterStoriesByCategory = (content, category) => {
  const groupItems = filterByCategory(content.allWpPost.nodes, 'Homeowner Stories');
  return take(filterByCategory(groupItems, category), 3);
};
